export const environment = {
  production: true,
  version: "1.4.10",
  appName: 'Maker Search Admin', //change this will effect the wording in many places in the app
  searchEngineUrl: 'https://sydney.kimisearch.com'
};
